module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/spacing-horizontal-be08fc8f2fec8b2f1b2bfb3de4993170.svg";